import { render, staticRenderFns } from "./NewHotelsList.vue?vue&type=template&id=21b9bc4e&scoped=true&"
import script from "./NewHotelsList.vue?vue&type=script&lang=js&"
export * from "./NewHotelsList.vue?vue&type=script&lang=js&"
import style0 from "./NewHotelsList.vue?vue&type=style&index=0&id=21b9bc4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b9bc4e",
  null
  
)

export default component.exports